export default __webpack_public_path__ + "static/media/13.0abf9d25.jpg";